import __vue_normalize__ from 'vue-runtime-helpers/dist/normalize-component.mjs';
import script from './HseTextArea.vue_rollup-plugin-vue=script.js';

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._b({staticClass:"hse-TextArea hse-Input",class:[
    _vm.classes.root,
    {
      'hse-TextArea_disabled hse-Input_disabled': _vm.disabled,
      'hse-TextArea_error hse-Input_error': _vm.error,
      'hse-TextArea_fullWidth hse-Input_fullWidth': _vm.fullWidth,
      'hse-TextArea_focus hse-Input_focus': _vm.focused,
      'hse-TextArea_autosize': _vm.autosize
    }
  ]},'div',_vm.rootProps,false),[_c('textarea',_vm._g(_vm._b({ref:"textarea",staticClass:"hse-TextArea__textarea",class:[
      _vm.classes.textArea,
      {
        'hse-TextArea__textarea_autosize': _vm.autosize,
        'hse-TextArea__textarea_disabled': _vm.disabled,
        'hse-TextArea__textarea_hasCounter': _vm.hasCounter,
        'focus-visible': _vm.focused
      }
    ],style:([{ resize: _vm.resize }, _vm.inputStyle]),attrs:{"disabled":_vm.disabled,"maxlength":_vm.maxLength},domProps:{"value":_vm.valueState}},'textarea',_vm.$attrs,false),_vm.listeners)),_vm._v(" "),(_vm.hasCounter)?_c('div',{staticClass:"hse-TextArea__counter",class:[
      _vm.classes.counter,
      {
        'hse-TextArea__counter_error': _vm.counterErrorValue
      }
    ]},[_vm._t("counter",[_vm._v("\n      "+_vm._s(_vm.counterValue)+"\n    ")])],2):_vm._e()])};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;
